import * as C from './consts';

export function getDashboard(search={}) {
    return {
        types: C.GET_DASHBOARD,
        url: `/api/content/video_projects/dashboard`,
        search
    };
}
